import { ApiClient } from "@ucl/library";
import { AuthorizedCreditReportResultDTO } from "../types/AuthorizedCreditReportResultDTO";
import { CreditAuthorizationReadDTO } from "../types/CreditAuthorizationReadDTO";
import { CreditAuthorizationUpdateDTO } from "../types/CreditAuthorizationUpdateDTO";

class CreditAuthorizationsApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getCreditAuthorizationResult = async (creditAuthorizationId: string) => {
    return this._apiClient.get<AuthorizedCreditReportResultDTO>(`api/CreditAuthorizations/${creditAuthorizationId}/result`);
  };

  getCreditAuthorizationById = async (creditAuthorizationId: string) => {
    return this._apiClient.get<CreditAuthorizationReadDTO>(
      `api/CreditAuthorizations/${creditAuthorizationId}`
    );
  };

  updateCreditAuthorization = async (creditAuthorizationId: string, updateDTO: CreditAuthorizationUpdateDTO) => {
    return this._apiClient.put<CreditAuthorizationReadDTO>(
      `api/CreditAuthorizations/${creditAuthorizationId}`,
      updateDTO
    );
  };

  downloadCreditReportPdf = async (creditAuthorizationId: string) => {
    return this._apiClient.downloadWithFileName(
      `api/CreditAuthorizations/${creditAuthorizationId}/download-pdf`,
    );
  };
}

export default CreditAuthorizationsApiClient;
